import React from "react";
import ReactDOM from "react-dom/client";

import { I18nextProvider } from 'react-i18next'
import reportWebVitals from "./reportWebVitals";

import i18n from "./Traductor/i18n";
import App from "./App";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
